module.exports = "<h1 id=\"开关--d-switch\">开关  d-switch</h1>\n";